var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNumber4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    rx: 11,
    fill: "#1EA1F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.536 15.5V13.532H7.432V12.164L11.44 6.56H13.144V12.164H14.452V13.532H13.144V15.5H11.536ZM8.632 12.752L8.344 12.164H11.536V7.844L11.956 7.976L8.632 12.752Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumber4);
export default __webpack_public_path__ + "static/media/number4.b616b03cd4f2c3458d45c49ca37339e9.svg";
export { ForwardRef as ReactComponent };